import React from 'react';

// base
import Card from '../../../../../base/card';
import Col from '../../../../../base/col';
import Placeholder from '../../../../../base/placeholder';
import Row from '../../../../../base/row';

export default class Loading extends React.PureComponent {
  render() {
    return (
      <React.Fragment>
        {
          [...new Array(2)].map((_, i) => (
            <Card {...{
              key: i,
              border: 'thin',
              className: 'min-height-50 vertical-align margin-bottom-10',
            }}>
              <Row className='width-100pct' nested>
                <Col s={12}>
                  <Placeholder lines={1} />
                </Col>
                <Col s={12}>
                  <Placeholder lines={1} />
                </Col>
              </Row>
            </Card>
          ))
        }
      </React.Fragment>
    )
  }
}